<template>
  <div>
    <div class="tabs">
      <div
        class="tab"
        @click="selectType(1)"
        :class="{ active: selectedType === 1 }"
      >
        <strong>1</strong>rap
      </div>
      <div
        class="tab"
        @click="selectType(2)"
        :class="{ active: selectedType === 2 }"
      >
        <strong>거리/시간</strong>
      </div>
      <div
        class="tab"
        @click="selectType(3)"
        :class="{ active: selectedType === 3 }"
      >
        <strong>페이스</strong>
      </div>
    </div>
    <!-- //tabs -->

    <div class="calcul">
      <!-- 시간(초) 내용 -->
      <div v-show="selectedType === 1">
        <div class="distanceInput no-line">
          <ul>
            <li><span>400m</span></li>
            <li class="time-inputs-div">
              <select name="" id="seconds1" @change="updateTime"></select>
            </li>
            <li><span>초</span></li>
          </ul>
          <p class="time-txt">{{ formattedTime }}</p>
        </div>
      </div>

      <!-- 거리/시간 내용 -->
      <div v-show="selectedType === 2">
        <div class="distanceInput">
          <strong class="tit-unit">총 거리</strong>
          <ul>
            <li class="select">
              <select
                name=""
                id="timeSelect"
                @change="updateButtonState"
                v-model="timeSelect"
              >
                <option value="0" selected>0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="21.0975">half</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="40">41</option>
                <option value="40">42</option>
                <option value="42.195">full</option>
              </select>
            </li>
            <li>.</li>
            <li class="select">
              <select
                name=""
                id="timeSelect1"
                @change="updateButtonState"
                :disabled="isTimeSelectDisabled"
              >
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
            </li>
            <li><span>km</span></li>
          </ul>
        </div>

        <div class="time-inputs">
          <strong class="tit-unit">총 시간</strong>
          <div class="time-inputs-div">
            <select id="hours" @change="updateButtonState"></select>
          </div>
          <span class="unit">시</span>
          <div class="time-inputs-div">
            <select id="minutes" @change="updateButtonState"></select>
          </div>
          <span class="unit">분</span>
          <div class="time-inputs-div">
            <select id="seconds" @change="updateButtonState"></select>
          </div>
          <span class="unit">초</span>
        </div>
      </div>

      <div v-show="selectedType === 3">
        <div class="distanceInput">
          <strong class="tit-unit">페이스</strong>
          <ul>
            <li class="select">
              <select
                name=""
                id="timeSelectA"
                class="tal"
                @change="updateButtonState"
              ></select>
            </li>
            <li>:</li>
            <li class="select">
              <select
                name=""
                id="timeSelectA1"
                class="tal"
                @change="updateButtonState"
              >
                <option value="0">00</option>
                <option value="5">05</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="35">35</option>
                <option value="40">40</option>
                <option value="45">45</option>
                <option value="50">50</option>
                <option value="55">55</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="distanceInput">
          <strong class="tit-unit">Laps</strong>
          <ul>
            <li class="select">
              <!-- <div class="time-inputs-text">
                <input
                  type="number"
                  id="timeInputA"
                  v-model.number="timeInputA"
                  @focus="selectText($event)"
                />
              </div> -->
              <select id="timeInputA"></select>
            </li>
            <li>Laps</li>
          </ul>
        </div>
      </div>

      <div class="calcul-bottom">
        <button
          id="calculateButton"
          @click="calculateResult"
          v-bind:disabled="isCalculateDisabled"
        >
          계산
        </button>
      </div>
    </div>
    <!-- //calcul -->

    <div class="goal-div" v-show="showGoalDiv">
      <h3>필요한 페이스</h3>
      <ul>
        <li v-if="selectedType == 2">
          <span>Laps</span>
          <strong>{{ result.laps }} <i>Laps</i></strong>
        </li>
        <li v-if="selectedType == 3">
          <span>총거리</span>
          <strong>{{ result.totalDistance }} <i>m</i></strong>
        </li>
        <li v-if="selectedType == 3">
          <span>총시간</span>
          <strong>{{ result.totalTime }} </strong>
        </li>
        <li>
          <span>시속</span>
          <strong>{{ result.perHour }} <i>km/h</i></strong>
        </li>
        <li v-if="selectedType !== 1">
          <span>400m</span>
          <strong>{{ result.pace400 }} <i>초</i></strong>
        </li>
        <li v-if="selectedType !== 3">
          <span>1km</span>
          <strong>{{ result.pace1km }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrackCalculator",
  data() {
    return {
      selectedType: 1,
      showGoalDiv: false,
      timeInput: 100,
      timeInputA: 1,
      result: {
        laps: 0,
        perHour: 0,
        pace1km: "00:00",
        pace400: 0,
      },
      totalDistance: 0, // 총 거리 값 추적
      totalTime: { hours: 0, minutes: 0, seconds: 0 }, // 총 시간 값 추적
      timeSelect: "0", // #timeSelect의 값을 저장
      timeSelect1: "0", // #timeSelect1의 값을 저장
      timeSelectA: "4", // #timeSelectA의 값을 저장
      timeSelectA1: "0", // #timeSelectA1의 값을 저장
      // selectedSeconds:1,
      formattedTime: "1초", 
    };
  },
  mounted() {
    this.populateTimeOptions("hours", 0, 6); // 분
    this.populateTimeOptions("minutes", 0, 59); // 분
    this.populateTimeOptions("seconds", 0, 59); // 초
    this.populateTimeOptions("seconds1", 0, 200, 100); // 초
    this.populateTimeOptions("timeSelectA", 0, 20, 4); // 초
    this.populateTimeOptions("timeInputA", 0, 100, 1); // 초
    this.updateTime(); // 초기 표시값 업데이트
  },
  computed: {
    isCalculateDisabled() {
      if (this.selectedType === 3) {
        // selectedType이 3일 때 timeSelectA와 timeSelectA1 확인
        return this.timeSelectA === "0" && this.timeSelectA1 === "0";
      } else if (this.selectedType === 2) {
        // 총 거리와 총 시간 값 체크
        return (
          this.totalDistance === 0 ||
          (this.totalTime.hours === 0 &&
            this.totalTime.minutes === 0 &&
            this.totalTime.seconds === 0)
        );
      }
      return false;
    },
    isTimeSelectDisabled() {
      // timeSelect의 값이 "half" 또는 "full"일 경우 timeSelect1을 비활성화
      return this.timeSelect === "21.0975" || this.timeSelect === "42.195";
    },
  },
  watch: {
    timeSelect(newValue) {
      // timeSelect 값이 "half" 또는 "full"일 경우 timeSelect1 값을 '0'으로 설정
      if (newValue === "21.0975" || newValue === "full") {
        this.timeSelect1 = "0";
      }
    },
  },
  methods: {
    populateTimeOptions(elementId, start, end, initialValue = start) {
      const selectElement = document.getElementById(elementId);
      // 기존 옵션 제거
      selectElement.innerHTML = "";
      for (let i = start; i <= end; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = `${i}`;
        if (i === initialValue) {
          option.selected = true; // 초기값 설정
        }
        selectElement.appendChild(option);
      }
      //console.log(initialValue);
    },
    selectText(event) {
      // 이벤트의 target 요소의 텍스트 전체 선택
      event.target.select();
    },
    sum() {
      document.querySelector(".goal-div").style.display = "block";
    },
    selectType(type) {
      this.selectedType = type;
      this.resetAll();
    },
    updateButtonState() {
      if (this.selectedType === 3) {
        // timeSelectA와 timeSelectA1 값 업데이트
        this.timeSelectA = document.getElementById("timeSelectA").value;
        this.timeSelectA1 = document.getElementById("timeSelectA1").value;
      } else {
        // 기존 로직 (selectedType === 2)
        const distanceSelect1 = parseFloat(
          document.getElementById("timeSelect").value
        );
        const distanceSelect2 = parseFloat(
          document.getElementById("timeSelect1").value
        );
        this.totalDistance = distanceSelect1 + distanceSelect2 / 10;

        this.totalTime.hours = parseInt(
          document.getElementById("hours").value,
          10
        );
        this.totalTime.minutes = parseInt(
          document.getElementById("minutes").value,
          10
        );
        this.totalTime.seconds = parseInt(
          document.getElementById("seconds").value,
          10
        );
      }
    },
    calculateResult() {
      if (this.selectedType === 1) {
        // console.log(this.seconds1)
        const totalSeconds = Number(document.getElementById("seconds1").value);

        if (isNaN(totalSeconds) || totalSeconds <= 0) {
          alert("유효한 값을 입력해주세요.");
          return;
        }

        const perHourSpeed = ((400 / totalSeconds) * 3600) / 1000;
        const pace1kmSeconds = totalSeconds * 2.5;
        const minutes = Math.floor(pace1kmSeconds / 60);
        const seconds = Math.floor(pace1kmSeconds % 60);
        const pace1km = `${String(minutes).padStart(2, "0")}:${String(
          seconds
        ).padStart(2, "0")}`;

        this.result = {
          laps: 1,
          perHour: perHourSpeed.toFixed(1),
          pace1km,
          pace400: totalSeconds,
        };
        this.showGoalDiv = true;
      } else if (this.selectedType === 2) {
        const distanceKm =
          parseFloat(document.getElementById("timeSelect").value) +
          parseFloat(document.getElementById("timeSelect1").value) / 10;

        const hours = parseInt(document.getElementById("hours").value, 10);
        const minutes =
          parseInt(document.getElementById("minutes").value, 10) || 0;
        const seconds =
          parseInt(document.getElementById("seconds").value, 10) || 0;

        const totalTimeSeconds = hours * 3600 + minutes * 60 + seconds;

        if (isNaN(distanceKm) || distanceKm <= 0 || totalTimeSeconds <= 0) {
          alert("유효한 거리와 시간을 입력해주세요.");
          return;
        }

        const perHourSpeed = (distanceKm / (totalTimeSeconds / 3600)).toFixed(
          1
        );
        const pacePerKm = totalTimeSeconds / distanceKm;
        const paceMinutes = Math.floor(pacePerKm / 60);
        const paceSeconds = Math.floor(pacePerKm % 60);

        const laps = Math.floor((distanceKm * 1000) / 400);

        this.result = {
          laps,
          perHour: perHourSpeed,
          pace1km: `${String(paceMinutes).padStart(2, "0")}:${String(
            paceSeconds
          ).padStart(2, "0")}`,
          pace400: (pacePerKm / 2.5).toFixed(1),
        };
        this.showGoalDiv = true;
      } else if (this.selectedType === 3) {
        // 랩 수와 1km 페이스 입력값 가져오기
        const lapCount =
          parseInt(document.getElementById("timeInputA").value, 10) || 0;
        const minutesPerKm =
          parseInt(document.getElementById("timeSelectA").value, 10) || 0;
        const secondsPerKm =
          parseInt(document.getElementById("timeSelectA1").value, 10) || 0;

        // 총 거리 계산 (400m 단위)
        const totalDistanceMeters = lapCount * 400;

        // 1km 페이스 (초로 변환)
        const totalSecondsPerKm = minutesPerKm * 60 + secondsPerKm;

        // 유효성 검사
        if (
          lapCount <= 0 ||
          totalDistanceMeters <= 0 ||
          totalSecondsPerKm <= 0
        ) {
          alert("유효한 랩 수와 1km 페이스를 입력해주세요.");
          return;
        }

        // 총 시간 (초): 1km당 페이스 × 총 거리 (km)
        const totalDistanceKm = totalDistanceMeters / 1000;
        const totalTimeSeconds = totalDistanceKm * totalSecondsPerKm;

        // 총 시간 포맷팅 (시간:분:초)
        const totalHours = Math.floor(totalTimeSeconds / 3600);
        const totalMinutes = Math.floor((totalTimeSeconds % 3600) / 60);
        const totalSeconds = Math.floor(totalTimeSeconds % 60);

        // 총 시간 문자열 생성
        let totalTimeFormatted;
        if (totalHours === 0) {
          // 시간 생략 (분:초)
          totalTimeFormatted = `${totalMinutes}:${String(totalSeconds).padStart(
            2,
            "0"
          )}`;
        } else {
          // 시간 포함 (시간:분:초)
          totalTimeFormatted = `${totalHours}:${String(totalMinutes).padStart(
            2,
            "0"
          )}:${String(totalSeconds).padStart(2, "0")}`;
        }

        // 시속 계산
        const perHourSpeed = (3600 / totalSecondsPerKm).toFixed(1);

        // 400m 페이스 계산
        const pace400 = (totalSecondsPerKm / 2.5).toFixed(1);

        // 총거리 세 자리마다 쉼표 추가
        const totalDistanceFormatted = totalDistanceMeters.toLocaleString();

        // 결과 업데이트
        this.result = {
          laps: lapCount,
          totalDistance: totalDistanceFormatted, // 쉼표가 추가된 총거리
          totalTime: totalTimeFormatted,
          perHour: perHourSpeed,
          pace400,
          pace1km: `${String(minutesPerKm).padStart(2, "0")}:${String(
            secondsPerKm
          ).padStart(2, "0")}`,
        };
        this.showGoalDiv = true;
      }
    },
    resetAll() {
      this.timeInput = 100;
      this.showGoalDiv = false;
      this.result = {
        laps: 0,
        perHour: 0,
        pace1km: "00:00",
        pace400: 0,
      };

      // 상태 초기화
      this.totalDistance = 0;
      this.totalTime = { hours: 0, minutes: 0, seconds: 0 };

      const inputs = document.querySelectorAll("input");
      inputs.forEach((input) => {
        input.value = "";
      });
      // 각 select 요소를 초기값으로 재설정
      this.populateTimeOptions("hours", 0, 6, 0); // 시간 초기값 0
      this.populateTimeOptions("minutes", 0, 59, 0); // 분 초기값 0
      this.populateTimeOptions("seconds", 0, 59, 0); // 초 초기값 0
      this.populateTimeOptions("seconds1", 0, 200, 100); // seconds1 초기값 100
      this.populateTimeOptions("timeSelectA", 0, 20, 4); // timeSelectA 초기값 4
      this.populateTimeOptions("timeInputA", 0, 100, 1); // timeInputA 초기값 1

      this.timeSelect = 0;
      this.updateTime();
    },
    updateTime() {
      this.selectedSeconds = Number(document.getElementById("seconds1").value);
      const minutes = Math.floor(this.selectedSeconds / 60); // 분 계산
      const seconds = this.selectedSeconds % 60; // 초 계산
      this.formattedTime = `${minutes > 0 ? `${minutes}분 ` : ""}${seconds}초`; // 분/초 포맷
    },
  },
};
</script>




<style scoped>
.goal-div {
  background: #fff;
  padding: 1.5em 1em 1em;
  flex: 1;
  border-radius: 0.8em;
  text-align: left;
  box-sizing: border-box;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.goal-div > h3 {
  font-size: 1em;
  margin-bottom: 0.8em;
  font-weight: bold;
}

.goal-div > ul {
}

.goal-div > ul > li {
  font-size: 0.9em;
  display: flex;
  align-items: center;
  height: 1.9em;
}

.goal-div > ul > li > span {
  width: 4em;
  color: #555;
  font-size: 0.9em;
}

.goal-div > ul > li > strong {
  flex: 1;
}

.goal-div > ul > li > span > i,
.goal-div > ul > li > strong > i {
  font-size: 0.5em;
  color: #666;
  letter-spacing: -0.1em;
  font-style: normal;
}
.etc-div {
  height: auto;
}
.distanceInput {
  margin-top: 0;
}
.distanceInput + .distanceInput {
  margin-top: 25px;
}
.time-inputs {
  margin-top: 25px;
}
.time-inputs > .unit {
  margin-left: -5px;
  font-size: 14px;
}
.time-txt{text-align: right; padding-right: 20px; margin-top: 5px; color: #fff; opacity: .6; font-size: 12px;}
.distanceInput > ul > li > select{text-align: right; text-align-last: right;}


</style>
  